/**
 * Trigger: tr_accounts_insert_fix_position
 * Purpose: Fix position conflicts when inserting a new account
 * Table: accounts
 * Event: BEFORE INSERT
 */
export const TR_ACCOUNTS_INSERT_FIX_POSITION = `
CREATE TRIGGER tr_accounts_insert_fix_position
BEFORE INSERT ON accounts FOR EACH ROW
BEGIN
  UPDATE accounts
  SET position = (
      SELECT COALESCE(MAX(position), 0) + 1 FROM accounts WHERE is_deleted = 0
    ),
    updated_at = strftime('%s', 'now')
  WHERE is_deleted = 0
    AND new.position <> (
      SELECT COALESCE(MAX(position), 0) + 1 FROM accounts WHERE is_deleted = 0
    )
    AND new.position = position;
END;
`;
